<template>
  <div class="min-h-screen bg-[#101c2f] relative">
    <div class="fixed inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-emerald-900/15 via-transparent to-transparent pointer-events-none"></div>

    <aside class="fixed inset-y-0 left-0 z-50 w-72 bg-slate-900/95 border-r border-slate-700/50 flex flex-col">
      <div class="p-6 border-b border-slate-700/50">
        <router-link to="/company-man" class="flex items-center gap-3 group">
          <div class="w-11 h-11 rounded-2xl bg-gradient-to-br from-emerald-400 to-cyan-400 flex items-center justify-center">
            <img src="/src/assets/images/icons/oilbuddy_logo.png" alt="OilBuddy" class="w-6 h-6" />
          </div>
          <div>
            <div class="text-xl font-bold text-white group-hover:text-emerald-300 transition">OilBuddy</div>
            <p class="text-xs text-slate-400">Company Man Portal</p>
          </div>
        </router-link>
      </div>

      <nav class="flex-1 px-4 py-5 space-y-6 overflow-y-auto">
        <div>
          <p class="px-3 text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-2">Main</p>
          <router-link to="/company-man" class="nav-item" exact-active-class="active">Dashboard</router-link>
        </div>
        <div>
          <p class="px-3 text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-2">Operations</p>
          <router-link to="/company-man/field-tickets" class="nav-item" active-class="active">Field Tickets</router-link>
          <router-link to="/company-man/reports" class="nav-item" active-class="active">Daily Reports</router-link>
          <router-link to="/company-man/tanks" class="nav-item" active-class="active">Tank Battery</router-link>
          <router-link to="/company-man/tank-watch" class="nav-item" active-class="active">Tank Watch</router-link>
          <router-link to="/company-man" class="nav-item">Alerts</router-link>
        </div>
        <div>
          <p class="px-3 text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-2">Safety</p>
          <router-link to="/company-man/safety" class="nav-item" active-class="active">Safety & Compliance</router-link>
        </div>
      </nav>

      <div class="p-4 border-t border-slate-700/50">
        <div class="flex items-center justify-between gap-2">
          <div>
            <p class="text-sm font-semibold text-white truncate">{{ userName }}</p>
            <p class="text-xs text-slate-400">Company Man</p>
          </div>
          <button type="button" class="text-xs text-slate-300 hover:text-white" @click="logout">Sign Out</button>
        </div>
      </div>
    </aside>

    <div class="pl-72 min-h-screen">
      <header class="sticky top-0 z-40 border-b border-slate-700/40 bg-[#101c2f]/80 backdrop-blur px-6 py-4 flex items-center justify-between">
        <div>
          <h1 class="text-lg font-semibold text-white">{{ pageTitle }}</h1>
          <p v-if="pageSubtitle" class="text-sm text-slate-400">{{ pageSubtitle }}</p>
        </div>
        <div class="w-9 h-9 rounded-full bg-emerald-500/20 text-emerald-300 flex items-center justify-center text-sm font-bold">
          {{ initials }}
        </div>
      </header>
      <main class="px-6 pb-10">
        <slot />
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useUserStore } from '@/stores/userStore'

defineProps<{
  pageTitle: string
  pageSubtitle?: string
}>()

const userStore = useUserStore()
const userName = computed(() => userStore.currentUser?.name || localStorage.getItem('user_name') || 'Company Man')
const initials = computed(() => {
  const n = userName.value.trim().split(/\s+/)
  return ((n[0]?.[0] || 'C') + (n[1]?.[0] || 'M')).toUpperCase()
})

function logout() {
  userStore.logout()
  window.location.href = '/#/login'
}
</script>

<style scoped>
.nav-item {
  display: block;
  padding: 10px 12px;
  border-radius: 10px;
  color: #c8d7e6;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  margin-bottom: 4px;
}
.nav-item:hover { background: rgba(15, 118, 110, 0.15); color: #fff; }
.nav-item.active { background: rgba(16, 185, 129, 0.18); color: #5eead4; }
.nav-item.muted { opacity: 0.7; }
</style>
